import _ from 'lodash/fp'
import { put, call, takeLatest } from 'redux-saga/effects'
import gql from 'graphql-tag'
import { makeSaga } from './util'

import apolloClient from '../apollo'
import { types, actions } from '../reducers/resetPassword'

const resetPasswordMutation = gql`
  mutation resetPassword($email: String!) {
    AuthMutations {
      resetPassword(input: { email: $email })
    }
  }
`

const confirmResetPasswordMutation = gql`
  mutation confirmResetPassword($token: String!, $password: String!) {
    AuthMutations {
      confirmResetPassword(input: { token: $token, password: $password })
    }
  }
`

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * resetPasswordRequestEffect ({ email }) {
  try {
    const result = yield call(apolloClient.mutate, { mutation: resetPasswordMutation, variables: { email } })
    return { data: _.get('data.AuthMutations.resetPassword', result) }
  } catch (error) {
    return { error }
  }
}

export function * resetPasswordConfirmEffect ({ token, password }) {
  try {
    const result = yield call(apolloClient.mutate, {
      mutation: confirmResetPasswordMutation,
      variables: { token, password }
    })
    return { data: _.get('data.AuthMutations.confirmResetPassword', result) }
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

/**
 * takeLatest(types.SUBMIT_REQUEST, resetPasswordRequestFlow)
 */
export function * resetPasswordRequestFlow ({ payload }) {
  const result = yield call(resetPasswordRequestEffect, payload)

  if (result.error) {
    yield put(actions.submitError(result))
  } else {
    yield put(actions.submitSuccess(result))
  }
}

/**
 * takeLatest(types.SUBMIT_REQUEST, resetPasswordConfirmFlow)
 */
export function * resetPasswordConfirmFlow ({ payload }) {
  const result = yield call(resetPasswordConfirmEffect, payload)

  if (result.error) {
    yield put(actions.confirmError(result))
  } else {
    yield put(actions.confirmSuccess(result))
  }
}

export default makeSaga([
  takeLatest(types.SUBMIT_REQUEST, resetPasswordRequestFlow),
  takeLatest(types.CONFIRM_REQUEST, resetPasswordConfirmFlow)
])
